import { Style } from './style.model';
import { AuditableRowModel } from '../../Forms/models/auditable-row.model';

export class StyleRowModel
    extends AuditableRowModel {

    style: Style;
    type: string;
    tooltipInfo: string;

    constructor(style: Style) {
        super();

        this.constructFromStyle(style);
    }

    public setType(type: string): void {
        this.type = type;
    }

    private constructFromStyle(style: Style): void {
        this.style = style;
        this.name = style.name;
        this.createdDate = style.createdDate ? new Date(style.createdDate) : null;
        this.createdByUser = style.createdByUserId;
        this.modifiedDate = style.lastModifiedDate ? new Date(style.lastModifiedDate) : null;
        this.modifiedByUser = style.lastModifiedByUserId;
    }
}
